module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAABaCAYAAAB5XDy9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAN5JREFUeNpskE0OAUEQhauqzRA/EQtXsOAkLuEKjmbnJiycQGIhEjLo6S6vajJEmMXLe/XV6+k0rTa6FmLqCREFkyTClEWVVJiJRTMiGwAlUaO+p4QVpyEgZmt4Nzs1IGLL+d1gis0pPlNpYrscqBZNDchSODAXI1xZQlLGP7KtFNatLRYB8R4hPbZrWIPNPRNoKCEdr3UA0gNSF5B+Ban6AH6hMsK53IaQ59XOG7f0fkEcTNs4quCO1za6TM5f8TBDnJ6+Zh9Z7AF2c7yuu38rb8ErK//M7FtutfsSYAAuRn2yyBPjygAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/8.png
// module id = cOvP
// module chunks = 1